import { useCallback, useReducer } from 'react';
import { cacheProvider } from '@logz-pkg/frontend-services';
import { OPEN360_MOVE_NOTICE_SNOOZE_KEY_PREFIX, OPEN360_MOVE_NOTICE_SNOOZE_MS } from './constants';
import { useFeatureFlagState, useSessionState } from 'ui/state/hooks';
import { useIsNewAppEnabled } from 'ui/hooks/is-new-application-enabled.hook';

interface IUseOpen360MoveNoticeResult {
  isVisible: boolean;
  snooze: () => void;
}

export const useOpen360MoveNotice = (): IUseOpen360MoveNoticeResult => {
  const { isFeatureEnabled } = useFeatureFlagState('Open360MoveNotice');
  const { isNewAppEnabled, isFetched } = useIsNewAppEnabled();
  const { loggedInUser } = useSessionState();
  // localStorage isn't reactive, so snoozing forces the re-read below.
  const [, forceRerender] = useReducer((count: number) => count + 1, 0);

  const snoozeKey = loggedInUser?.id ? `${OPEN360_MOVE_NOTICE_SNOOZE_KEY_PREFIX}-${loggedInUser.id}` : null;
  const isSnoozed = snoozeKey ? Boolean(cacheProvider.getPersistentTtl<boolean>(snoozeKey)) : false;

  const snooze = useCallback((): void => {
    if (snoozeKey) cacheProvider.setPersistentTtl(snoozeKey, true, OPEN360_MOVE_NOTICE_SNOOZE_MS);

    forceRerender();
  }, [snoozeKey]);

  const isVisible = Boolean(isFeatureEnabled && isFetched && !isNewAppEnabled && snoozeKey && !isSnoozed);

  return { isVisible, snooze };
};
